import { partnerClient } from '@/modules/core/services';
import { AddCampaignFormStringValues } from '../../components/ParticipantRecluitment/CampaignTracking/components/AddCampaignForm/AddCampaignForm.types';
import { ICampaign } from './campaign.type';
import { isAxiosErrorGuard } from '@/common/utils/types/axios';

export type IAddCampaignResponse = ICampaign;

export const ADD_CAMPAIGN_MUTATION_KEY = 'add-campaign';
export const addCampaign = async ({
  campaignName,
  campaignSource,
  campaignTerm,
  campaignMedium,
  campaignContent,
  launchDate,
  endDate,
  volumeDistribution,
}: AddCampaignFormStringValues): Promise<IAddCampaignResponse> => {
  try {
    const data = await partnerClient.post('campaign_tracking', {
      campaignName,
      campaignSource,
      campaignTerm,
      campaignMedium,
      campaignContent,
      launchDate,
      endDate,
      volumeDistribution: volumeDistribution?.map((item) => ({
        distributionDate: item.distributionDate,
        numberOfEnrollees: Number(item.numberOfEnrollees),
      })),
    });
    return data.data;
  } catch (error: unknown) {
    if (isAxiosErrorGuard(error)) {
      throw new Error('An error occurred while creating the campaign', {
        cause: error,
      });
    }
    throw new Error(String(error));
  }
};

export const EDIT_CAMPAIGN_MUTATION_KEY = 'edit-campaign';
export const editCampaign = async ({
  campaignID,
  campaignName,
  campaignSource,
  campaignTerm,
  campaignMedium,
  campaignContent,
  launchDate,
  endDate,
  volumeDistribution,
}: AddCampaignFormStringValues): Promise<IAddCampaignResponse> => {
  try {
    const data = await partnerClient.put(`campaign_tracking`, {
      campaignID,
      campaignName,
      campaignSource,
      campaignTerm,
      campaignMedium,
      campaignContent,
      launchDate,
      endDate,
      volumeDistribution: volumeDistribution?.map((item) => ({
        distributionDate: item.distributionDate,
        numberOfEnrollees: Number(item.numberOfEnrollees),
      })),
    });
    return data.data;
  } catch (error: unknown) {
    if (isAxiosErrorGuard(error)) {
      throw new Error('An error occurred while updating the campaign', {
        cause: error,
      });
    }
    throw new Error(String(error));
  }
};
